import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

export const authContract = c.router({
  signUp: {
    method: "POST",
    path: "/auth/signup",
    responses: {
      201: z.object({
        accessToken: z.string(),
      }),
      400: z.object({
        message: z.string(),
      }),
    },
    body: z.object({
      firstName: z.string().optional(),
      lastName: z.string().optional(),
      email: z.string(),
      password: z.string(),
    }),
    summary: "Sign up",
  },

  requestResetPassword: {
    method: "POST",
    path: "/auth/reset-password",
    responses: {
      201: z.object({}),
    },
    body: z.object({
      email: z.string().email(),
    }),
    summary: "Request reset password",
  },

  login: {
    method: "POST",
    path: "/auth/login",
    responses: {
      201: z.object({
        accessToken: z.string(),
      }),
    },
    body: z.object({
      email: z.string().email(),
      password: z.string(),
    }),
    summary: "Login to the application",
  },

  resetPassword: {
    method: "POST",
    path: "/auth/reset-password/:token",
    responses: {
      201: z.object({}),
    },
    body: z.object({
      password: z.string(),
    }),
    summary: "Reset password",
  },

  loginWithMicrosoft: {
    method: "POST",
    path: "/auth/login/microsoft",
    body: z.object({}),
    responses: {
      302: z.object({
        redirectUrl: z.string(),
      }),
    },
    summary: "Login with Microsoft",
  },

  microsoftCallback: {
    method: "GET",
    path: "/auth/login/microsoft/callback",
    query: z.object({
      code: z.string().optional(),
      state: z.string().optional(),
      error: z.string().optional(),
    }),
    responses: {
      302: z.object({
        redirectUrl: z.string(),
      }),
    },
    summary: "Microsoft callback",
  },
});
